module Meevo.Plugins.AppointmentBook.Services {
    export class AppointmentBookAutoScroll {
                
        restrict = "A";

        link = (scope: any, ele: any, attrs: angular.IAttributes) => {
            let selectedOffSet = 0;
            let amountScrolled = 0;
            let scrollAreaLeft = 0;
            let selectedWidth = 0;

            ele.find(".move-button").on("click", function () {
                scrollAreaLeft = ele.find("#scroll-area").innerWidth();
                selectedWidth = ele.find(".selected").innerWidth();
                selectedOffSet = ele.find(".selected").offset().left - ele.find("#scroll-area").offset().left;
                amountScrolled = ele.find("#scroll-area").scrollLeft();

                if (selectedOffSet + amountScrolled < amountScrolled) {
                    ele.find("#scroll-area").scrollLeft(amountScrolled + selectedOffSet);
                }
                //console.log("indexOf selected: ", scope.vm.items.indexOf(scope.vm.selectedItem));
                if (amountScrolled == selectedOffSet && scope.vm.items.indexOf(scope.vm.selectedItem) == 0) {
                    ele.find("#scroll-area").scrollLeft(-(amountScrolled - selectedOffSet) - selectedOffSet / 2);
                }
                if ((selectedOffSet + selectedWidth) > scrollAreaLeft) {
                    ele.find("#scroll-area").scrollLeft(((selectedOffSet - scrollAreaLeft) + selectedOffSet / 2) + amountScrolled);
                }
            });
        }

        constructor() { };
        
        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new AppointmentBookAutoScroll();
            };
            directive.$inject = []
            return directive;
        }
    }

    angular.module('ApptBookApp').directive('appointmentBookAutoScroll', AppointmentBookAutoScroll.factory());
}